module.exports = __webpack_public_path__ + "static/media/border-line-type.cd128f06.svg";